<template>
  <v-row>
    <v-dialog
      v-model="editUnitDialog"
      persistent
      max-width="800px"
      height="1300px"
    >
      <v-card>
        <v-toolbar dark color="secondary" max-height="64px">
          <v-card-title>
            <i class="fal fa-cabinet-filing mr-2" />
            <span class="headline">Edit {{ unit.name }}</span>
          </v-card-title>
          <v-spacer />
          <button
            type="button"
            class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
            @click="close"
            :disabled="isLoading"
          >
            <i class="fal fa-times" />
          </button>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  v-model="unit.curriculum_id"
                  name="curriculum"
                  label="Curriculum"
                  :items="curriculums"
                  :disabled="isLoading"
                  :loading="isLoading"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.id"
                  @change="fetchCourses"
                  :menu-props="{ closeOnClick: true }"
                >
                  <template v-slot:selection="data">
                    {{ data.item.name }} &nbsp;
                    <span
                      :class="
                        data.item.is_draft
                          ? 'text-small'
                          : 'text-success text-small'
                      "
                      >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                    >
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ data.item.name }}
                        <span
                          :class="
                            data.item.is_draft
                              ? 'text-small'
                              : 'text-success text-small'
                          "
                          >({{
                            data.item.is_draft ? 'Draft' : 'Published'
                          }})</span
                        >
                      </v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.company_author.name"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
                <span
                  class="kt-font-danger validate-error"
                  v-show="errors.has('unit.curriculum_id')"
                  >{{ errors.first('unit.curriculum_id') }}</span
                >
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  v-model="unit.course_id"
                  name="course"
                  :disabled="unit.curriculum_id == null || isLoading"
                  :loading="isLoading"
                  label="Course (Select A Curriculum To be able to select Course)"
                  :items="courses"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.id"
                  @change="fetchModules"
                  :menu-props="{ closeOnClick: true }"
                >
                  <template v-slot:selection="data">
                    {{ data.item.name }} &nbsp;
                    <span
                      :class="
                        data.item.is_draft
                          ? 'text-small'
                          : 'text-success text-small'
                      "
                      >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                    >
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.name }} &nbsp;
                    <span
                      :class="
                        data.item.is_draft
                          ? 'text-small'
                          : 'text-success text-small'
                      "
                      >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                    >
                  </template>
                </v-autocomplete>
                <span
                  class="kt-font-danger validate-error"
                  v-show="errors.has('unit.course_id')"
                  >{{ errors.first('unit.course_id') }}</span
                >
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  v-model="unit.module_id"
                  :disabled="unit.course_id == null || isLoading"
                  :loading="isLoading"
                  name="module_id"
                  label="Module (Select A Course To be able to select Module)"
                  @change="fetchSeries"
                  :items="modules"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.id"
                  :menu-props="{ closeOnClick: true }"
                >
                  <template v-slot:selection="data">
                    {{ data.item.name }} &nbsp;
                    <span
                      :class="
                        data.item.is_draft
                          ? 'text-small'
                          : 'text-success text-small'
                      "
                      >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                    >
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.name }} &nbsp;
                    <span
                      :class="
                        data.item.is_draft
                          ? 'text-small'
                          : 'text-success text-small'
                      "
                      >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                    >
                  </template>
                </v-autocomplete>
                <span
                  class="kt-font-danger validate-error"
                  v-show="errors.has('module_id')"
                  >{{ errors.first('module_id') }}</span
                >
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  v-model="unit.series_id"
                  :disabled="unit.module_id == null || isLoading"
                  name="series_id"
                  :label="`Series (Select A Module To be able to select Series)`"
                  :items="series"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.id"
                  :menu-props="{ closeOnClick: true }"
                  :loading="isLoading"
                >
                  <template v-slot:selection="data">
                    {{ data.item.name }} &nbsp;
                    <span
                      :class="
                        data.item.is_draft
                          ? 'text-small'
                          : 'text-success text-small'
                      "
                      >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                    >
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.name }} &nbsp;
                    <span
                      :class="
                        data.item.is_draft
                          ? 'text-small'
                          : 'text-success text-small'
                      "
                      >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                    >
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                :cols="
                  unit.content.includes('iframe') || unit.content_file
                    ? '6'
                    : '12'
                "
                sm="12"
                :md="
                  unit.content.includes('iframe') || unit.content_file
                    ? '6'
                    : '12'
                "
              >
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="unit.name"
                    label="Unit Name"
                    name="name"
                    v-validate="'required'"
                  ></v-text-field>
                  <span
                    class="kt-font-danger validate-error"
                    v-show="errors.has('name')"
                    >{{ errors.first('name') }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="thumbnail"
                    label="Thumbnail URL"
                    name="thumbnail"
                    accept="image/*"
                    @click="toggleUploadDialog"
                  ></v-text-field>
                  <span v-if="unit.thumbnail">
                    <a :href="unit.thumbnail" target="_blank">Current Image</a>
                  </span>
                  <span
                    class="kt-font-danger validate-error"
                    v-show="errors.has('thumbnail')"
                    >{{ errors.first('thumbnail') }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <label>Quiz</label>
                  <multiselect
                    v-model="unit.quiz_id"
                    :options="quizzes"
                    label="title"
                    track-by="id"
                    searchable
                    @search-change="searchQuizzes"
                    placeholder="Select a Quiz"
                    :loading="quizPagination.loading"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.title }}</strong>
                    </template>
                    <span slot="noOptions">Search Quiz...</span>
                    <span slot="noResult">
                      Oops! No elements found. Consider changing the search
                      query.
                    </span>
                    <template slot="afterList">
                      <div
                        v-observe-visibility="nextQuizPage"
                        v-if="
                          quizPagination.current !== quizPagination.last_page
                        "
                      />
                    </template>
                  </multiselect>
                </v-col>
                <v-col v-if="unit.content_file" cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="unit.call_guide_link"
                    label="Call Guide"
                    name="call_guide_link"
                    @click="toggleCallGuideDialog"
                  ></v-text-field>
                </v-col>
              </v-col>
              <v-col
                v-if="unit.content.includes('iframe') || unit.content_file"
                cols="6"
                sm="12"
                md="6"
              >
                <v-card v-if="unit.content.includes('iframe')" class="mx-auto">
                  <span v-html="unit.content"></span>

                  <v-card-title> Current Video </v-card-title>

                  <v-card-subtitle>
                    <v-text-field
                      v-model="unit.video_duration"
                      label="Video Duration"
                      name="video_duration"
                    ></v-text-field>
                  </v-card-subtitle>
                </v-card>
                <v-card v-else>
                  <iframe
                    :src="unit.content_file"
                    style="width: 100%; height: 200px"
                  ></iframe>
                  <v-card-title size="small"> Current PDF File </v-card-title>

                  <v-col cols="12" sm="12" md="12">
                    <v-file-input
                      v-model="content_file"
                      label="Upload PDF File"
                      name="content_item"
                      accept="application/pdf,"
                    ></v-file-input>
                  </v-col>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-col v-if="!unit.content_file" cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="unit.call_guide_link"
                    label="Call Guide"
                    name="call_guide_link"
                    @click="toggleCallGuideDialog"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <div class="form-group">
                    <label>(Additional) Content</label>
                    <jodit-vue v-model="unit.content"></jodit-vue>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <label>Description</label>
                  <jodit-vue
                    name="description"
                    v-model="unit.description"
                    :buttons="[]"
                    :config="{
                      uploader: { url: 'none' },
                    }"
                  >
                  </jodit-vue>
                  <span
                    class="kt-font-danger validate-error"
                    v-show="errors.has('description')"
                    >{{ errors.first('description') }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-combobox
                    v-model="unit.tags"
                    label="Tags"
                    name="tags"
                    :items="tags"
                    :item-text="(item) => item.name"
                    :item-value="(item) => item.id"
                    multiple
                    chips
                    prepend-icon="fal fa-tags"
                    :menu-props="{ closeOnClick: true }"
                  ></v-combobox>
                  <span
                    class="kt-font-danger validate-error"
                    v-show="errors.has('tags')"
                    >{{ errors.first('tags') }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-switch
                    v-model="unit.is_draft"
                    :label="`Draft`"
                    :disabled="isLoading"
                    :loading="isLoading"
                  ></v-switch>
                </v-col>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue-grey darken-1"
            text
            @click="close"
            :disabled="isLoading"
            :loading="isLoading"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="update"
            :disabled="isLoading"
            :loading="isLoading"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <upload-file-dialog
      :type="['image']"
      :show-upload-dialog="showUploadDialog"
      :upload-dialog="toggleUploadDialog"
      :close-dialog="closeUploadDialog"
      v-on:showImage="getThumbnail"
    />
    <upload-file-dialog
      :type="'all'"
      :show-upload-dialog="showCallGuideDialog"
      :upload-dialog="toggleCallGuideDialog"
      :close-dialog="closeUploadDialog"
      v-on:showImage="getCallGuide"
    />
  </v-row>
</template>

<script>
import Multiselect from 'vue-multiselect';
import UploadFileDialog from '@/components/dialogs/UploadFileDialog';
import {
  forEach as _forEach,
  debounce as _debounce,
  sortBy as _sortBy,
  isEmpty as _isEmpty,
  findIndex as _findIndex,
} from 'lodash-es';
export default {
  name: 'editUnit.vue',
  components: {
    Multiselect,
    UploadFileDialog,
  },
  props: {
    unit: Object,
    editUnitDialog: Boolean,
    closeModal: Function,
  },
  data() {
    return {
      thumbnail: null,
      content_file: null,
      isLoading: false,
      curriculums: [],
      modules: [],
      courses: [],
      series: [],
      tags: [],
      quizzes: [],
      quizPagination: {
        current: 1,
        last_page: 1,
        loading: false,
      },
      showUploadDialog: false,
      showCallGuideDialog: false,
    };
  },
  watch: {
    editUnitDialog(val) {
      val || this.close();
    },
  },
  computed: {
    curriculums() {
      return this.$store.state.curriculums.curriculums;
    },
    curriculumsReady() {
      return this.$store.state.isCurriculumsReady;
    },
  },
  created() {
    if (this.unit) {
      this.$store.dispatch('units/fetchTags').then(({ data }) => {
        this.tags = data;
      });
      this.fetchCurriculums();
      if (this.unit.curriculum_id) this.fetchCourses();
      if (this.unit.course_id) this.fetchModules();
      if (this.unit.module_id) this.fetchSeries();
    }
  },
  methods: {
    fetchCurriculums() {
      if (!this.curriculumsReady) {
        this.isLoading = true;
        this.setCurriculums();
        this.isLoading = false;
      }
    },
    setFormData() {
      const form = new FormData();
      form.append('name', this.unit.name);
      form.append('description', this.unit.description);
      form.append('module_id', this.unit.module_id);
      form.append('series_id', this.unit.series_id);
      form.append('call_guide_link', this.unit.call_guide_link);
      form.append('video_duration', this.unit.video_duration);
      form.append('is_draft', this.unit.is_draft);
      form.append('content', this.unit.content);
      if (this.unit.quiz_id) {
        form.append('quiz_id', this.unit.quiz_id.id);
      }
      _forEach(this.unit.tags, (tag) => {
        typeof tag === 'object'
          ? form.append('tags[]', tag.id)
          : form.append('tags[]', tag);
      });
      form.append('thumbnail', this.thumbnail);

      return form;
    },

    close() {
      this.editUnitDialog = false;
      this.closeModal();
    },

    update() {
      this.isLoading = true;
      this.$store
        .dispatch('units/editUnit', {
          payload: this.setFormData(),
          id: this.unit.id,
        })
        .then((data) => {
          this.$notify('success', 'Unit updated!');
          this.$emit('updateUnit', data.data);
          this.close();
        })
        .catch((error) => {
          this.interactWithErrorBag(error, this.errors);
        })
        // eslint-disable-next-line no-return-assign
        .finally(() => (this.isLoading = false));
    },

    fetchCourses() {
      this.isLoading = true;

      this.axios
        .get('/client/lms/fetchCurriculumCourses', {
          params: { curriculum_id: this.unit.curriculum_id },
        })
        .then(({ data }) => {
          this.courses = data;
          this.$nextTick(() => {
            this.isLoading = false;
          });
        });
    },
    fetchModules() {
      this.isLoading = true;
      this.axios
        .get('/client/lms/fetchCourseModules', {
          params: {
            course_id: this.unit.course_id,
          },
        })
        .then(({ data }) => {
          this.modules = data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log('something went wrong with fetching categories');
          this.isLoading = false;
        });
    },
    fetchSeries() {
      this.isLoading = true;
      this.axios
        .get('/client/lms/fetchSeries', {
          params: { module_id: this.unit.module_id },
        })
        .then(({ data }) => {
          this.series = data;
          this.$nextTick(() => {
            this.isLoading = false;
          });
        });
    },

    fetchQuizzes() {
      this.quizPagination.loading = true;
      const page = _isEmpty(this.search) ? this.quizPagination.current : 1;
      this.axios
        .get('lms-manager/builder/quizzes', {
          params: {
            page,
            type: 'Active',
            itemsPerPage: 5,
            search: this.search,
          },
        })
        .then(({ data }) => {
          _forEach(data.data, (quiz) => {
            const index = _findIndex(this.quizzes, { id: quiz.id });
            if (index === -1) {
              this.quizzes.push(quiz);
            }
          });
          if (_isEmpty(this.search)) {
            this.quizPagination.last_page = data.last_page;
          }
          this.quizPagination.loading = false;
        })
        .catch((error) => {
          this.quizPagination.loading = false;
        });
    },

    toggleUploadDialog() {
      this.showUploadDialog = true;
    },
    toggleCallGuideDialog() {
      this.showCallGuideDialog = true;
    },
    closeUploadDialog() {
      this.showUploadDialog = false;
      this.showCallGuideDialog = false;
    },
    getThumbnail(item) {
      this.unit.thumbnail = item.value;
      if (item.type == 'upload') {
        this.thumbnailDisplay = URL.createObjectURL(this.unit.thumbnail);
      } else {
        this.thumbnailDisplay = this.unit.thumbnail;
      }
    },
    getCallGuide(item) {
      this.unit.call_guide_link = item.value;
    },

    searchQuizzes: _debounce(function (query) {
      this.search = query;
      this.fetchQuizzes();
    }, 500),
  },
};
</script>

<style scoped></style>
